module.exports = __webpack_public_path__ + "static/media/nike_store(1).71410824.jpg";